import React from "react";

const LinkIcon: React.FC = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0598 10.94C15.3098 13.19 15.3098 16.83 13.0598 19.07C10.8098 21.31 7.16985 21.32 4.92985 19.07C2.68985 16.82 2.67985 13.18 4.92985 10.94"
        stroke="#374151"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5909 13.41C8.25094 11.07 8.25094 7.27001 10.5909 4.92001C12.9309 2.57001 16.7309 2.58001 19.0809 4.92001C21.4309 7.26001 21.4209 11.06 19.0809 13.41"
        stroke="#374151"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export default LinkIcon;
